import { Collection, MultilineInput } from "@tblabs/truffle";
import { CollectionItemPrinter } from "../../Utils/CollectionItemPrinter";
import { TableItem } from "../../../Models/Description/Table/TableItem";
import { Row } from "../../Utils/Row";


export class TableItemEditor extends CollectionItemPrinter<TableItem>
{
    constructor(row: TableItem, rows: Collection<TableItem>)
    {
        super(row, rows, [row.Left.value]);

        this.AddContent(
            new Row(
                new MultilineInput(row.Left).Placeholder("Lewa kolumna (markdown)"),
                new MultilineInput(row.Right).Placeholder("Prawa kolumna (markdown)"),
            ),
        )
    }
}
